module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/crocodile-2.1627042a.png";